/**
 * Representa as fases dentro de uma etapa de um núcleo do PLM (Product Lifecycle Management)
 */
export enum EnumFasePLM {
  Nascimento = 1,
  Crescimento = 2,
  Fortalecimento = 3,
  Maturidade = 4,
  Encerramento = 5,
}

export const FASE_PLM_LABELS: Record<EnumFasePLM, string> = {
  [EnumFasePLM.Nascimento]: 'Nascimento',
  [EnumFasePLM.Crescimento]: 'Crescimento',
  [EnumFasePLM.Fortalecimento]: 'Fortalecimento',
  [EnumFasePLM.Maturidade]: 'Maturidade',
  [EnumFasePLM.Encerramento]: 'Encerramento',
};

/** Descrições para cada fase do PLM */
export const FASE_PLM_DESCRIPTIONS: Record<EnumFasePLM, string> = {
  [EnumFasePLM.Nascimento]: 'Fase de nascimento dentro da etapa de monitoramento do núcleo de desempenho',
  [EnumFasePLM.Crescimento]: 'Fase de crescimento dentro da etapa de monitoramento do núcleo de desempenho',
  [EnumFasePLM.Fortalecimento]: 'Fase de fortalecimento dentro da etapa de monitoramento do núcleo de desempenho',
  [EnumFasePLM.Maturidade]: 'Fase de maturidade dentro da etapa de monitoramento do núcleo de desempenho',
  [EnumFasePLM.Encerramento]: 'Fase de encerramento dentro da etapa de monitoramento do núcleo de desempenho',
};
